export default __webpack_public_path__ + "static/media/offmusic.897a9d0b.svg";